import React, { useEffect, useRef } from "react";

import { MdAdd } from "@react-icons/all-files/md/MdAdd";
import { MdDelete } from "@react-icons/all-files/md/MdDelete";
import { MdRemove } from "@react-icons/all-files/md/MdRemove";
import classNames from "classnames";
import { unstable_renderSubtreeIntoContainer } from "react-dom";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom-v5-compat";

import { Price } from "../Atoms";
import { CartItem } from "../Cart/schema";
import { deleteCartItem, updateCartItem } from "../CartItem/cartItemRequests";
import { ItemCountdown } from "../Sections/Section";
import { useSession, useSessionDispatch } from "../Session/SessionContext";
import { useFetchLiveItemCountdown } from "../queries";

export const PendingCartItem = ({
  cartItem,
  inSoldOutError,
}: {
  cartItem: CartItem;
  inSoldOutError?: boolean;
}) => {
  const { t } = useTranslation();
  const dispatch = useSessionDispatch();
  const { cart } = useSession();
  const itemCountdownQuery = useFetchLiveItemCountdown(cartItem.itemId);

  const removeOrderItem = async () => {
    const response = await deleteCartItem(cart.uuid, cartItem.id);
    dispatch({
      action: "removeCartItem",
      payload: { cartItemId: cartItem.id },
    });
  };
  const soldOut =
    inSoldOutError ||
    (itemCountdownQuery.data &&
      cartItem.multiplier > itemCountdownQuery.data.remainingCount);
  const canIncreaseMultiplier =
    !inSoldOutError &&
    itemCountdownQuery.data &&
    cartItem.multiplier < itemCountdownQuery.data.remainingCount;

  const updateMultiplier = (newMultiplier: number) => async () => {
    const response = await updateCartItem({
      id: cartItem.id,
      cartId: cart.uuid,
      multiplier: newMultiplier,
    });
    dispatch({
      action: "updateCartItem",
      payload: {
        id: cartItem.id,
        multiplier: newMultiplier,
      },
    });
  };

  return (
    <div
      key={cartItem.id}
      className={classNames(
        "flex bg-venue-tertiary shadow-venue-brand-style rounded-venue-brand p-12 flex-wrap text-base font-medium items-center gap-8",
        {
          "outline outline-2 outline-venue-highlight": soldOut,
        },
      )}
    >
      {cartItem.itemHeroImageUrl && (
        <div className="flex-none">
          <div className="  flex-none aspect-w-1 aspect-h-1 w-[80px] ">
            <img
              src={cartItem.itemHeroImageUrl}
              className="rounded-venue-brand object-cover"
            />
          </div>
        </div>
      )}
      <div className="flex-1">
        <div className="flex space-x-8">
          <Link to={`/order-items/${cartItem.itemId}/${cartItem.id}`}>
            {cartItem.itemName}
          </Link>
          {soldOut && (
            <div className="flex items-center">
              <ItemCountdown count={itemCountdownQuery.data?.remainingCount} />
            </div>
            // <div className="flex items-center bg-venue-highlight text-venue-tertiary font-semibold text-xs rounded-venue-brand px-8">
            //   <div>{t("items.soldOut")}</div>
            // </div>
          )}
        </div>
        <div>
          <Price value={cartItem.totalSalesPriceTaxInclusive} />
        </div>
        <ul className="text-xs font-normal list-disc">
          {cartItem.itemMods.map((mod) => mod.name).join(", ")}
        </ul>
      </div>
      <div>
        <div className="items-center gap-2 flex py-2 px-2 bg-venue-secondary rounded-full">
          {cartItem.multiplier > 1 ? (
            <a
              className="cursor-pointer p-4"
              onClick={updateMultiplier(cartItem.multiplier - 1)}
            >
              <MdRemove className="text-[16px]" />
            </a>
          ) : (
            <a
              className="cursor-pointer text-venue-primary text-lg p-4"
              onClick={removeOrderItem}
            >
              <MdDelete className="text-[16px]" />
            </a>
          )}
          <div> {cartItem.multiplier} </div>
          {canIncreaseMultiplier ? (
            <a
              className="cursor-pointer text p-4"
              onClick={updateMultiplier(cartItem.multiplier + 1)}
            >
              <MdAdd className="text-[16px]" />
            </a>
          ) : (
            <a className="p-4 invisible">
              <MdAdd className="text-[16px]" />
            </a>
          )}
        </div>
      </div>
    </div>
  );
};
